import { commonAxios } from '@/plugins/axios'
import { CompactSign, compactDecrypt } from 'jose'

const baseURL = '/v1/common/init'

export const getEnv = async () => {
  if (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_IS_LOCALHOST) {
    return {
      LIFF_ID: process.env.VUE_APP_LIFF_ID,
      BASE_URL: process.env.VUE_APP_BASE_URL,
      SHOP_ID: process.env.VUE_APP_SHOP_ID,
      CLIENT_ID: process.env.VUE_APP_CLIENT_ID,
      LINE_BOT_ID: process.env.VUE_APP_LINE_BOT_ID,
      IMAGE_API: process.env.VUE_APP_IMAGE_API,
      GTM_ID: process.env.VUE_APP_GTM_ID,
      GMO_SHOP_ID: process.env.VUE_APP_GMO_SHOP_ID,
      AMAZON_PAY_CLIENT_API: process.env.VUE_APP_AMAZON_CLIENT_ID,
      AMAZON_PAY_MERCHANT_ID: process.env.VUE_APP_AMAZON_MERCHANT_ID,
      AMAZON_PAY_PUBLIC_KEY: process.env.VUE_APP_AMAZON_PUBLIC_KEY,
    }
  }

  const secretKey = new TextEncoder().encode(process.env.VUE_APP_SECRET_KEY)

  const jws = await new CompactSign(new TextEncoder().encode(JSON.stringify({ domain: window.location.origin })))
    .setProtectedHeader({ alg: 'HS256' })
    .sign(secretKey)

  const { data } = await commonAxios.get(baseURL, {
    headers: {
      'x-api-key': jws,
    },
  })

  const { plaintext } = await compactDecrypt(data, secretKey)

  return JSON.parse(new TextDecoder().decode(plaintext))
}
